module.exports = __webpack_public_path__ + "img/buildings-icon.b60e83f7.svg";